var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 484 484",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M242,0C108.6,0,0,108.6,0,242s108.6,242,242,242s242-108.6,242-242S375.4,0,242,0z M242,433.9    c-105.8,0-191.9-86.1-191.9-191.9S136.2,50.1,242,50.1S433.9,136.2,433.9,242S347.8,433.9,242,433.9z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.3,228.4c-11.7-6.5-24.1-11.3-36.4-16.4c-7.1-2.9-13.9-6.4-19.9-11.2c-11.8-9.5-9.6-24.8,4.3-30.9    c3.9-1.7,8-2.3,12.2-2.5c16.1-0.9,31.3,2.1,45.9,9.1c7.2,3.5,9.6,2.4,12.1-5.1c2.6-8,4.8-16.1,7.1-24.1c1.6-5.4-0.4-9-5.5-11.2    c-9.3-4.1-18.9-7.1-29-8.6c-13.1-2.1-13.1-2.1-13.2-15.3c-0.1-18.7-0.1-18.7-18.7-18.6c-2.7,0-5.4-0.1-8.1,0    c-8.7,0.3-10.2,1.8-10.4,10.5c-0.1,3.9,0,7.9,0,11.8c-0.1,11.7-0.1,11.5-11.3,15.5c-27,9.8-43.7,28.2-45.5,57.7    c-1.6,26.1,12,43.7,33.4,56.5c13.2,7.9,27.8,12.6,41.8,18.8c5.5,2.4,10.7,5.2,15.2,9c13.5,11.1,11,29.6-5,36.6    c-8.6,3.7-17.6,4.7-26.8,3.5c-14.3-1.8-28-5.5-40.8-12.2c-7.5-3.9-9.7-2.9-12.3,5.3c-2.2,7.1-4.2,14.2-6.1,21.3    c-2.6,9.6-1.7,11.9,7.5,16.3c11.6,5.6,24.1,8.5,36.8,10.6c9.9,1.6,10.3,2,10.4,12.3c0,4.7,0.1,9.4,0.1,14c0.1,5.9,2.9,9.3,9,9.4    c6.9,0.1,13.8,0.1,20.7,0c5.6-0.1,8.5-3.2,8.6-8.9c0-6.4,0.3-12.8,0.1-19.2c-0.3-6.5,2.5-9.8,8.8-11.5    c14.4-3.9,26.7-11.7,36.2-23.2C330.5,295.7,320.5,249,283.3,228.4z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.7940a729.svg";
export { ForwardRef as ReactComponent };